export const __DEV__ = process.env.NEXT_PUBLIC_DEV_MODE === 'true';
export const DEVICE_STORAGE_KEY = 'gotedo_streams_device_preferences';
export const STREAM_STATE_KEY = 'gotedo_stream_session';
export const cssPrefix = 'lk';
export const ACCESS_TOKEN_KEY = 'gotedo_streams_access_token';
export const PKCE_DATA_KEY = 'gotedo_streams_oauth2_pkce_data';
